import React from 'react';
import ChoroplethSvg from '@splunk/dashboard-visualizations/ChoroplethSvg';
import { campusSvg } from '../../mockdata/campusSvg.js';

const baseProps = {
    width: 700,
    height: 500,
    options: {
        svg: campusSvg,
    },
};

export default () => <ChoroplethSvg {...baseProps} />;
